<template>
    <div class="operator-selector">
        <div class="radios">
            <radio-selectors :options="modes" :value="[mode]" @input="changeMode"></radio-selectors>
            <span>the following operators</span>
        </div>
        <div class="list">
            <template v-for="(selection, index) in displayListForSelectedOperators">
                <input-button
                    v-if="selection.length" :key="index" class="operator"
                    icon="remove" @click-inner="removeOperator(index)"
                >
                    {{ operatorLabel[selection] }}
                </input-button>
                <select
                    v-else :key="index" :value="selection" class="dropdown-select form-control"
                    @input="updateOperator(index, $event)"
                >
                    <option v-for="(operator) in operators" :key="operator.value" :value="operator.value">
                        {{ operator.label }}
                    </option>
                </select>
            </template>
        </div>
    </div>
</template>

<script>

    import RadioSelectors from './RadioSelectors';
    import InputButton from './InputButton';

    export default {
        name: 'OperatorSelector',
        components: {
            InputButton,
            RadioSelectors,
        },
        props: {
            value: {
                type: Object,
                default() {
                    return {
                        include: [],
                        exclude: [],
                    };
                },
            },
            config: {
                type: Object,
                default() {
                    return {
                        operators: [],
                    };
                },
            },
        },
        data() {
            return {
                modes: {
                    include: 'Only include',
                    exclude: 'Exclude',
                },
                modeValue: 'include',
            };
        },
        computed: {
            mode() {
                if (this.value.exclude.length === this.value.include.length) {
                    return this.modeValue;
                }
                return this.value.exclude.length > this.value.include.length ? 'exclude' : 'include';
            },
            operators() {
                const firstSelectionLabel = `Select operator to ${this.mode}...`;
                const moreSelectionsLabel = 'Select another operator...';
                return [{
                    label: this.selectedOperators.length === 0 ? firstSelectionLabel : moreSelectionsLabel,
                    value: '',
                }].concat(this.config.options);
            },
            selectedOperators() {
                return this.value[this.mode];
            },
            displayListForSelectedOperators() {
                return this.selectedOperators.concat(['']);
            },
            operatorLabel() {
                const list = {};
                this.config.options.forEach((operator) => {
                    list[operator.value] = operator.label;
                });
                return list;
            },
        },
        watch: {
            mode(newValue) {
                this.modeValue = newValue;
            },
        },
        methods: {
            changeMode(value) {
                [this.modeValue] = value;
                this.sendOperators(value);
            },
            updateOperator(index, event) {
                this.selectedOperators[index] = event.target.value;
                this.sendOperators(this.mode);
            },
            removeOperator(index) {
                this.selectedOperators.splice(index, 1);
                this.sendOperators(this.mode);
            },
            sendOperators(mode) {
                const model = {
                    include: [],
                    exclude: [],
                };
                model[mode] = this.selectedOperators.filter((operator) => operator !== '');
                this.$emit('input', model);
            },
        },
    };

</script>

<style lang="scss" scoped>

</style>
